import { useEffect, useState } from 'react';
import { fetchAssetData, fetchPageData, fetchUserData } from '../../../api/statisticsApi';
import moment from 'moment';
import { filter } from 'rambda';

// Refactor: Extract API calls into a utility function
export const getPageData = async (selectedSite, startDate, endDate) => {
    const filter = `site IN (${selectedSite.map(site => `'${site.value.replace(/'/g, "''")}'`).join(', ')}) AND eventTime >= '${startDate.format("YYYY-MM-DD")}' AND eventTime < '${moment(endDate).add(1, "day").format("YYYY-MM-DD")}' AND userId Like '%@shell.com'`;
    return fetchPageData(filter);
};

export const getUserData = async (selectedSite, startDate, endDate) => {
    const filter = `site IN (${selectedSite.map(site => `'${site.value.replace(/'/g, "''")}'`).join(', ')}) AND eventTime >= '${startDate.format("YYYY-MM-DD")}' AND eventTime < '${moment(endDate).add(1, "day").format("YYYY-MM-DD")}' AND userId Like '%@shell.com'`;
    return fetchUserData(filter);
};


export const getAssetData = async (selectedSite, startDate, endDate) => {
    const filter = `site IN (${selectedSite.map(site => `'${site.value.replace(/'/g, "''")}'`).join(', ')}) AND eventTime >= '${startDate.format("YYYY-MM-DD")}' AND eventTime < '${moment(endDate).add(1, "day").format("YYYY-MM-DD")}' AND userId Like '%@shell.com'`;
    return fetchAssetData(filter);
};

// Updated usePageData hook
const usePageData = (selectedSite, startDate, endDate) => {
    const [userPageData, setUserPageData] = useState([]);
    const [pageData, setPageData] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            const statisticData = await getPageData(selectedSite, startDate, endDate);
            setLoading(false);

            if (Array.isArray(statisticData) && statisticData.length > 0) {
                const total = statisticData.reduce((pre, curr) => pre + curr.count, 0);
                const dataCreate = statisticData.map(obj => ({
                    page: obj.page,
                    views: obj.count,
                    viewsPrecentage: Math.round((obj.count / total) * 100),
                    id: obj.page,
                }));
                setPageData(dataCreate);
            } else {
                setUserPageData(null);
            }
        };

        fetchData();
    }, [selectedSite, startDate, endDate]);

    useEffect(() => {
        const fetchAdditionalData = async () => {
            if (pageData?.length > 0) {
                setLoading(true);

                const userStatisticData = await getUserData(selectedSite, startDate, endDate);
                if (userStatisticData?.length > 0) {
                    const dataCreate = pageData.map(obj => {
                        const matchingUser = userStatisticData.find(user => user.page === obj.page);
                        obj.user = matchingUser ? matchingUser.count : 0;
                        return obj;
                    });
                    setUserPageData(dataCreate);
                }

                const assetStatisticData = await getAssetData(selectedSite, startDate, endDate);
                setLoading(false);

                if (assetStatisticData?.length > 0) {
                    setUserPageData(prev => {
                        const old = [...prev];
                        const dataCreate = old.map(obj => {
                            const count = assetStatisticData.reduce((acc, cur) => 
                                cur?.page === obj.page ? ++acc : acc, 0);
                            obj.asset = count;
                            return obj;
                        });
                        return dataCreate;
                    });
                }
            }
        };

        fetchAdditionalData();
    }, [pageData, selectedSite, startDate, endDate]);

    return { userPageData, loading };
};

export default usePageData;

